/**
 * `<DataTable>` ids that more than one layer needs to spell. A table's id **is the root of its list
 * query key** (`[tableId, {page, pageSize, sort, filters}, request]`), so a mutation that must
 * refresh a table has to agree with the page on one string — the shipped `WARRANTY_TABLE_ID`
 * arrangement, one layer up.
 *
 * Homed in `config` rather than in either feature because the two consumers live in **different**
 * features: `pages/customers` renders the table and `features/device-params` refreshes it after a
 * Parameter Template is applied. `config` may import only `types`/`lib` and every other layer may
 * import `config`, so this cannot become the feature↔feature cycle ADR-0024 exists to prevent.
 * Route paths live one file over for the same reason (ADR-0010).
 */
export const customerDevicesTableId = (customerId: string) => `customer-${customerId}-devices`;
